import script from "./supplement-actions-button.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-actions-button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__